export const TAB_BALANCE = 'Balance';
export const TAB_STATEMENT = 'Statements';
export const TAB_UNBILLED = 'Unbilled Flights';